<template>
   <div class='comparison-graph-wrapper'>
      <chart :chart-data="chartOptions"/>
   </div>
</template>

<script>
import Chart from '../../../../organisms/Home/Chart';
import { mapGetters } from 'vuex';
import { formatCurrency } from '../../../../../js/ui-helpers';

const commonYAxisProps = {
   labels: {
      formatter: function() {
         return formatCurrency(this.value, {withDecimals: false});
      },
   },
};

const tooltip = { 
   formatter: function ()
   {
      return this.points.reduce( (acc, point) =>
         {
            return `${acc}<br/>
               <span style="font-size: 1.4em; color:${point.series.color};">•</span>
               ${point.series.name}: <b>${formatCurrency(point.y)}</b>`;
         }, `${this.x}`);
   },
};

const codeToNameMap = {
   "shs": "SHS",
   "mhp": "MHP",
   "grid": "Grid",
   "solar_minigrid": "SMG",
};

export default {
   name: 'comparison-graphs',
   components: {
      Chart,
   },
   computed: {
      ...mapGetters(["getBatResults"]),
      chartOptions()
      {
         const results = this.getBatResults;
         console.assert(results, "no results");

         let series = [];
         let categories = [];
         if (results)
         {
            categories = [...results.energy_costs.shs.cost_series.years]; // have to use spread to remove unpredictive reference problems
            series = Object.entries(codeToNameMap).filter(([code]) => !(results.is_in_terai && code==='mhp')).reduce((accumlated,[energyCode, energyName]) =>
            {
               const { levelized_costs,life_cycle_costs } = results.energy_costs[energyCode].cost_series;
               return [
                  ...accumlated,
                  { name: `Levelized Cost (${energyName})`,  data: [...levelized_costs],  type: 'spline', yAxis: 0 },
                  { name: `Life Cycle Cost (${energyName})`, data: [...life_cycle_costs], type: 'spline', yAxis: 1 },
               ];
            }, []);
         }
         return {
            title: { text: "Combined Graph of Life Cycle Cost and Levelized Cost", y: 18 },
            tooltip,
            series,
            xAxis: { categories, crosshair: true },
            yAxis: [
               { title: { text: 'Levelized Cost' }, ...commonYAxisProps },
               { title: { text: 'Life Cycle Cost' }, opposite: true, ...commonYAxisProps },
            ],
         };
      },
   },
}
</script>

<style lang="scss" scoped>
.comparison-graph-wrapper {
   height: 30em;
}
</style>
